const themeContract = {
  tu: {
    heading: {
      color: 'brand-1',
      marginBottom: 'lg'
    },
    container: {
      marginBottom: 'xl'
    }
  },
  argos: {
    heading: {
      color: 'grey-90',
      marginBottom: 'lg'
    },
    container: {
      marginBottom: 'lg'
    }
  },
  habitat: {
    heading: {
      color: 'brand-1',
      marginBottom: 'lg'
    },
    container: {
      marginBottom: 'lg'
    }
  },
  nectar: {
    heading: {
      color: 'purple-90',
      marginBottom: 'lg'
    },
    container: {
      marginBottom: 'xl'
    }
  },
  sainsburys: {
    heading: {
      color: 'grey-80',
      marginBottom: 'lg'
    },
    container: {
      marginBottom: 'xl'
    }
  }
}

export { themeContract }
